module.exports = __webpack_public_path__ + "static/media/Gotham-Light.bceda3fa.otf";